import React from 'react'
import { Page, Document, StyleSheet, View, Text} from '@react-pdf/renderer'
import { tableColumnStyle } from '../pdf_cst';
import PhoneRequestTable from '../ContentLayout/ObjectsListing/PhoneRequestTable';

const styles = StyleSheet.create(tableColumnStyle);

export default function ObjectsResultPDF ({data}) {

    const styles = StyleSheet.create({...tableColumnStyle,
        row: {
            flexDirection: 'row',
            marginBottom: 32
        },
        TitleContact : {
            flexDirection: 'column'

        },
        email : {
            textAlign: "center"
        }

    })

    //count the number of items in data that have IsProblem = true
    const count = data.reduce((acc, item) => item.IsProblem ? acc + 1 : acc, 0)

    return (
        <Document title={"PhoneRequests.pdf"}>
            <Page 
                size="A4" 
                style={styles.page}
            >
                { count > 0 ? 
                <Text
                    style={styles.warning}
                >
                    {count} line(s) to check!
                </Text> : null }
                <View>
                    <PhoneRequestTable items={data} />
                </View>
                <Text
                    fixed
                    style={styles.BottomEmail}
                >
                    www.native-auctions.com
                </Text>
                <Text 
                    fixed
                    style={styles.PageNumber} 
                    render={({ pageNumber, totalPages }) => (
                        `${pageNumber} / ${totalPages}`
                    )} 
                />
            </Page>
        </Document>
    )
}